import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import frenchi18n from '@assets/i18n/fr.json';
import { ConsentService } from '@modules/process/pages/consent/services/consent.service';
import { ProcessEventFactory } from '@shared/models/processEvents';
import { TrackerService } from '@shared/services/tracker.service';
import { ProcessEventService } from '@shared/services/process-event.service';
import { StoreService } from '@shared/services/store.service';

@Component({
  selector: 'app-cancel-open-banking-popin',
  templateUrl: './cancel-open-banking-popin.component.html',
})
export class CancelOpenBankingPopinComponent implements OnChanges {
  @Input() isCancelPopinOpen = false;
  @Input() isRefusingConsent = false;
  @Output() continue = new EventEmitter<void>();

  constructor(
    private consentService: ConsentService,
    private storeService: StoreService,
    private processEventService: ProcessEventService,
    private tracker: TrackerService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes?.isCancelPopinOpen?.previousValue === false &&
      changes.isCancelPopinOpen.currentValue === true
    ) {
      this.tracker.trackPage({ taggingPage: 'ABANDON_BANK_CONNECTION' });
    }
  }

  continueProcess() {
    this.tracker.trackClick({
      click: `${frenchi18n.common_no}${frenchi18n.cancel_popin_refused_continue}`,
      taggingPage: 'ABANDON_BANK_CONNECTION',
    });

    this.continue.emit();
  }

  rejected() {
    this.tracker.trackClick({
      click: `${frenchi18n.common_yes}${frenchi18n.cancel_popin_refused_exit}`,
      taggingPage: 'ABANDON_BANK_CONNECTION',
    });

    this.isCancelPopinOpen = false;

    if (this.isRefusingConsent) {
      this.consentService
        .sendConsent({
          userToken: this.storeService.getVariableOrThrow('OPEN_BANKING_USER_TOKEN'),
          userId: this.storeService.getVariableOrThrow('USER_ID'),
          hasConsented: false,
          cguVersion: this.storeService.getVariableOrThrow('CGU_VERSION'),
          termsVersion: this.storeService.getVariableOrThrow('TERMS_VERSION'),
        })
        .subscribe(() => this.processEventService.push(ProcessEventFactory.SpawnAbandonEvent()));
    } else {
      this.processEventService.push(ProcessEventFactory.SpawnAbandonEvent());
    }
  }
}
